import React from "react";
import { FileText, ShieldAlert, Headphones, CheckSquare, Gift, Terminal } from "lucide-react";
import GenericPremiumPage from "../../../customComponents/GenericPremiumPage";
import AffiliateProgramPage from "../AffiliateProgram";
import UserFeedbackPage from "../UserFeedback";
import OtcDeskPage from "../OtcDesk";
import OtcServicePage from "../OtcService";
import WhyAgcePage from "./WhyAgcePage";
import DownloadAppPage from "./DownloadAppPage";

export { AffiliateProgramPage, UserFeedbackPage, OtcDeskPage, OtcServicePage, WhyAgcePage, DownloadAppPage };

export const LicensePage = () => (
    <GenericPremiumPage
        title="Licenses & Registrations"
        subtitle="Fully compliant with global regulatory standards."
        icon={FileText}
        description="ARAB Global Exchange operates strictly under international regulatory frameworks. Our licenses ensure a secure and compliant trading environment for all users."
        contentTitle="Licensed & Regulated"
        ctaText="About Our Company"
        ctaLink="/about_us/company"
    />
);

export const LawEnforcementPage = () => (
    <GenericPremiumPage
        title="Law Enforcement Requests"
        subtitle="Working with global authorities to ensure a safe ecosystem."
        icon={ShieldAlert}
        description="We cooperate fully with global law enforcement agencies to prevent illicit activities and secure user assets."
        contentTitle="Official Requests"
        ctaText="Submit Request"
        ctaLink="mailto:compliance@arabglobal.ae?subject=Law%20Enforcement%20Request"
    />
);

export const SquarePage = () => (
    <GenericPremiumPage
        title="AGCX Square"
        subtitle="The pulse of the crypto community."
        icon={CheckSquare}
        description="Connect with top traders, discover breaking news, and share your market insights with the global ARAB Global community."
        contentTitle="Community Hub"
        ctaText="View Announcements"
        ctaLink="/announcement"
    />
);

export const AirDropPage = () => (
    <GenericPremiumPage
        title="AGCX Airdrops"
        subtitle="Exclusive token rewards for our loyal users."
        icon={Gift}
        description="Participate in our regular airdrops. Hold AGCX tokens, complete tasks, and get rewarded with the newest premium tokens."
        contentTitle="Active Campaigns"
        ctaText="View Active Airdrops"
        ctaLink="/airdrops"
    />
);


export const SubmitRequestPage = () => (
    <GenericPremiumPage
        title="Submit a Request"
        subtitle="Need help? Our 24/7 support team is here for you."
        icon={Headphones}
        description="Whether you have an issue with a trade, deposit, or just a general question, submit a request and our premium support team will respond instantly."
        contentTitle="We're Here to Help"
        ctaText="Contact Support"
        ctaLink="/contact"
    />
);

export const DevelopersPage = () => (
    <GenericPremiumPage
        title="Developer API & Docs"
        subtitle="Build powerful trading bots and integrations."
        icon={Terminal}
        description="Access our ultra-low latency REST and WebSocket APIs. Build the future of programmatic trading with our comprehensive documentation."
        contentTitle="Build with AGCX"
        ctaText="Read API Docs"
        ctaLink="/api-documentation"
    />
);
